import { createRouter, createWebHashHistory } from 'vue-router'
import intro from './views/introScherm.vue'
import redenContact from './views/redenContact.vue'
import vraag from './views/vraag.vue'
import gegevensInvoeren from './views/gegevensInvoeren.vue'
import controleren from './views/controleren.vue'
import bevestigen from './views/bevestigen.vue'
import error from './views/error.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: intro
  },
  {
    path: '/reden-contact',
      name: 'reden-contact',
      component: redenContact
  },
  {
      path: '/vraag',
      name: 'vraag',
      component: vraag
  },
  {
      path: '/gegevens-invoeren',
      name: 'gegevens-invoeren',
      component: gegevensInvoeren
  },
  {
      path: '/controleren',
      name: 'controleren',
      component: controleren
  },
  {
      path: '/bevestigen',
      name: 'bevestigen',
      component: bevestigen
  },
  {
      path: '/error',
      name: 'error',
      component: error
  }
]

export default createRouter({
  history: createWebHashHistory(),
  routes,
})